import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {CreativeTemplateTrackChangesState} from 'common/src/modules/creativeTemplates/store/creativeTemplatePage/creativeTemplateTrackChanges/creativeTemplateTrackChanges.types';

export const smartCreativeTrackChangesInitialState: CreativeTemplateTrackChangesState = {
  isUnsavedChangesMade: false,
  isInSavingProcess: false,
  isTemplateChangedByCollaborator: false,
};

const smartCreativeTrackChangesReducer = createSlice({
  name: `${BreadcrumbName.SmartCreativePage}/trackChanges`,
  initialState: smartCreativeTrackChangesInitialState,
  reducers: {
    resetTrackChangesState: () => smartCreativeTrackChangesInitialState,

    setIsUnsavedChangesMade: (state, action: PayloadAction<boolean>) => {
      state.isUnsavedChangesMade = action.payload;
    },

    setIsInSavingProcess: (state, action: PayloadAction<boolean>) => {
      state.isInSavingProcess = action.payload;
    },

    setIsTemplateChangedByCollaborator: (state, action: PayloadAction<boolean>) => {
      state.isTemplateChangedByCollaborator = action.payload;
    },
  },
});

export const {
  resetTrackChangesState,
  setIsUnsavedChangesMade,
  setIsInSavingProcess,
  setIsTemplateChangedByCollaborator,
} = smartCreativeTrackChangesReducer.actions;

export default smartCreativeTrackChangesReducer.reducer;
